export enum PAGE_ROUTES {
  HOME = '',
  SERVICES = '/services',
  CAREERS = '/careers',
  ABOUT_US = '/about-us',
  HIRE_US = '/hire-us',
}
